export const brand = {
  name: "Digital Chambers",
  company: "Chatake Innoworks",
  tagline: "Space for your finest work.",
  pilotName: "Mahesh Jagtap",
  quotaBytes: 5_000_000_000,
  maxUploadBytes: 20_000_000,
} as const;
